import { render } from "./VZDetailModal.vue?vue&type=template&id=34b398ad&ts=true"
import script from "./VZDetailModal.vue?vue&type=script&lang=ts"
export * from "./VZDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__